function frontEndControls() {
    (function($) {
        $(function() {
            const body = document.querySelector("body");
            const siteContent = document.querySelector(".site-content");
            const $backToTop = $(".mg-back-to-top");

            /**
             * Escape from full screen UI
             */
            body.onkeydown = function(e) {
                if (e.keyCode != 27) return;

                if ($(body).hasClass("fullscreen-menu")) {
                    // menu toggle button has logic
                    // to handle both the fullscreen & mobile menus
                    $(".menu-toggle").click();
                }

                if ($(".search-wrap").hasClass("animated")) {
                    $(".search-wrap").addClass("fadeOutDownBig");
                }
            };

            /**
             * Back to top
             */
            $backToTop.on("click", e => {
                e.preventDefault();
                $("html, body").animate({ scrollTop: 0 });
            });

            $(window).on("scroll", function() {
                const scrollFromTop = $(this).scrollTop();
                if (scrollFromTop > this.innerHeight) {
                    $backToTop.removeClass("hidden");
                } else {
                    $backToTop.addClass("hidden");
                }
            });
        });
    })(jQuery);
}

export default frontEndControls;



// WEBPACK FOOTER //
// ./src/js/partials/controls.js